import * as React from "react";
import { notifications } from "@mantine/notifications";
import i18n from "i18n";
import Icon from "components/common/Icon/Icon";
import { singleton } from "logic/singleton";
const UserNotification = {
  error(message, title) {
    notifications.show({
      message,
      // translated when shown, so it follows language changes
      title: title != null ? title : i18n.t("user_notification.error", { ns: "common" }),
      autoClose: 1e4,
      color: "red",
      icon: /* @__PURE__ */ React.createElement(Icon, { name: "exclamation", type: "regular" })
    });
  },
  warning(message, title) {
    notifications.show({
      message,
      title: title != null ? title : i18n.t("user_notification.attention", { ns: "common" }),
      color: "blue",
      icon: /* @__PURE__ */ React.createElement(Icon, { name: "exclamation", type: "regular", rotation: 180 })
    });
  },
  success(message, title) {
    notifications.show({
      message,
      title: title != null ? title : i18n.t("user_notification.success", { ns: "common" }),
      color: "green",
      icon: /* @__PURE__ */ React.createElement(Icon, { name: "check", type: "regular" })
    });
  }
};
export default singleton("core.UserNotification", () => UserNotification);
